import React, { useState } from "react"
import { Paper, Box } from "@mui/material"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import { dispatchSnackbar } from "src/v2/components/SnackBar/snackbar-bus"
import CetipVersaoFilterComponent from "../components/CetipVersaoFilter/cetip-versao-filter-component"
import ResumoConsolidadoStatus from "./componentes/resumo_consolidados_table"
import StatusAnaliticoCadastro from "./componentes/status_analitico_consolidados_table"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as FileIcon } from "src/v2/assets/icons/file-icon.svg"
import MotorStatusCadastroService from "src/services/motor-status-cadastro-service"

const StatusCadastroPage = () => {
    const [cetip, setCetip] = useState("")
    const [versaoDocumento, setVersaoDocumento] = useState("")
    const statusService = new MotorStatusCadastroService()

    const exportFile =async  () => {
        try {
            const response = await statusService.exportStatusAnaliticoCSV(cetip, versaoDocumento)

            dispatchSnackbar(
                response?.data?.mensagem || "Solicitação recebida. O arquivo será enviado por e-mail",
                "success"
            )
        } catch (error) {
            const errorMessage =
                error?.response?.data?.erro ||
                "Erro ao exportar CSV"

            dispatchSnackbar(errorMessage, "error")
        }
    }

    return (
        <SideBarLayout
            title="Status do Cadastro"
            header
            headerTitle="Status do Cadastro"
            headerImage={"/background/cadastro-background-header.jpg"}
            loading={false}
        >
            <Paper sx={{ p: 3, borderRadius: 0, mb: 2, mt: -2 }}>
                <ResumoConsolidadoStatus />
            </Paper>

            <Paper sx={{ p: 3, borderRadius: 0, mb: 2 }}>
                <Box display="flex" alignItems="auto" flexWrap="wrap" sx={{ mb: 2 }}>
                    <CetipVersaoFilterComponent
                        setCetip={setCetip}
                        setVersao={setVersaoDocumento}
                        returnCetipVersao={(c, v) => {
                            setCetip(c)
                            setVersaoDocumento(v)
                        }}
                        clearFilter={() => {
                            setCetip("")
                            setVersaoDocumento("")
                        }}
                    />
                    <Box sx={{ ml: "auto", mr: 2, mt: "-55px" }}> {/* mt -55px para alinhar com os botoes de filtro */}
                        <ButtonWithIcon icon={<FileIcon />} onClick={exportFile} > 
                            EXPORTAR CSV
                        </ButtonWithIcon>
                    </Box>
                </Box>

                <StatusAnaliticoCadastro cetip={cetip} versaoDocumento={versaoDocumento} />
            </Paper>
        </SideBarLayout>
    )
}

export default StatusCadastroPage